import { Navigate, useLocation } from 'react-router-dom';
import CorpDashboardApi from '../../services/CorpDashboardApi';

// Gates only the corporate dashboard. Every other route in this repo stays public.
function RequireCorpAuth({ children }) {
    const location = useLocation();

    if (!CorpDashboardApi.isAuthenticated()) {
        return (
            <Navigate
                to='/corporate-dashboard/login'
                replace
                state={{ from: location.pathname }}
            />
        );
    }

    return children;
}

export default RequireCorpAuth;
